<template>
  <div id="fefile">
    <input type="hidden" v-model="value" v-validate="inputValidate" :name="inputName" />
    <div class="file-upload-container">
      <div v-if="displayType && displayType === 'picWall'">
        <el-upload
          class="avatar-uploader"
          ref="elUploadEl"
          :file-list="files"
          list-type="picture-card"
          :action="actionUrl"
          :headers="header"
          :accept="accept"
          :data="expectParam"
          :limit="limit"
          :multiple="multiple"
          :before-upload="handleBeforeUpload"
          :on-progress="handleProgress"
          :on-exceed="handleExceed"
          :on-success="handleSuccess"
          :on-remove="removeFile"
          :on-error="handleError"
          :with-credentials="withCredentials"
        >
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              <span>附件格式支持：{{ acceptLabel }}</span>
              <br />
              <span>附件大小限制：单个文件不超过{{ size }}MB</span>
              <br />
              <span>附件个数限制：最多{{ limit }}个</span>
            </div>
            <i slot="default" class="el-icon-plus" v-if="inputWriteable"></i>
          </el-tooltip>
          <div slot="file" slot-scope="{ file }" style="width: 100%; height: 100%">
            <div
              :style="{
                background: `url(${file.url}) no-repeat center`
              }"
              class="imgBg"
            />
            <!-- <img :src="file.url" alt="" /> -->
            <!-- <p>{{ file }}</p> -->
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="preview(file)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <span class="el-upload-list__item-delete" @click="download(file)">
                <i class="el-icon-download"></i>
              </span>
              <span class="el-upload-list__item-delete" @click="removeFile(file)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
      </div>

      <template v-else>
        <el-upload
          ref="elUploadEl"
          v-if="isRelate ? getBtnPermission('audit_process_management_relate_admin') : true"
          :action="actionUrl"
          :file-list="files"
          :headers="header"
          :show-file-list="false"
          :accept="accept"
          :data="expectParam"
          :limit="limit"
          :multiple="multiple"
          :before-upload="handleBeforeUpload"
          :on-progress="handleProgress"
          :on-exceed="handleExceed"
          :on-success="handleSuccess"
          :on-error="handleError"
          :with-credentials="withCredentials"
        >
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              <span>附件格式支持：{{ acceptLabel }}</span>
              <br />
              <span>附件大小限制：单个文件不超过{{ size }}MB</span>
              <br />
              <span>附件个数限制：最多{{ limit }}个</span>
            </div>
            <el-button size="mini" round icon="el-icon-plus" v-if="inputWriteable">上传</el-button>
          </el-tooltip>
        </el-upload>
        <el-button
          size="mini"
          round
          icon="el-icon-delete"
          @click="handleClear"
          v-if="inputWriteable && files.length > 0 && isRelate ? getBtnPermission('audit_process_management_relate_admin') : inputWriteable"
          >清空</el-button
        >
        <slot name="append"></slot>
      </template>
    </div>
    <!-- <file-upload
      ref="fileUpload"
      :before-upload="beforeUpload"
      :on-success="uploadSuccess"
      :on-error="onError"
      :readonly="!inputWriteable"
      :withCredentials="withCredentials"
      :show-clear="filesData"
    >
      <slot slot="append" name="append"></slot>
    </file-upload> -->
    <fe-field-tail :fieldName="inputName" :inputValue="value" />
    <el-table
      v-if="filesData && filesData.length > 0 && displayType && displayType === 'fileName'"
      :data="filesData"
      style="margin-top: 10px"
      :show-header="false"
      size="medium"
    >
      <el-table-column label="附件名称" align="left" :show-overflow-tooltip="true" width="200">
        <template slot-scope="scope">
          <span :class="{ 'done-subject': previewable }" @click="preview(scope.row)" v-if="showDownload">{{ scope.row.name }}</span>
          <span v-if="!showDownload">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" v-if="inputWriteable || downloadable" width="60">
        <template slot-scope="scope">
          <i @click="removeFile(scope.row)" v-if="inputWriteable" class="el-icon-delete" style="cursor: pointer"></i>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      v-if="filesData && filesData.length > 0 && displayType && displayType === 'table'"
      :data="filesData"
      border
      style="width: 98%; margin-top: 10px; overflow-x: auto"
      size="medium"
    >
      <el-table-column label="序号" align="center" type="index" width="70"></el-table-column>
      <el-table-column label="附件名称" align="center" width="200">
        <template slot-scope="scope">
          <span :class="{ 'done-subject': previewable }" @click="preview(scope.row)" v-if="showDownload">{{ scope.row.name }}</span>
          <span v-if="!showDownload">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="calColumnShow.fileType" prop="type" align="center" lalign="center" width="100" label="附件类型"></el-table-column>
      <el-table-column v-if="calColumnShow.fileSize" align="center" lalign="center" width="150" label="附件大小">
        <template slot-scope="scope">{{ scope.row.size | computerSize }}</template>
      </el-table-column>
      <el-table-column v-if="inputWriteable" align="center" label="状态" width="120">
        <template slot-scope="scope">
          <el-progress type="circle" :width="25" :stroke-width="2" :percentage="scope.row.percentage" :status="scope.row.state || 'warning'"></el-progress>
        </template>
      </el-table-column>
      <el-table-column :prop="con.name" :label="con.desc" v-for="con in propConfList" :key="con.index" width="200" align="center">
        <template slot-scope="scope">
          <eco-input v-model="filesData[scope.$index][con.name]"></eco-input>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" v-if="inputWriteable || downloadable" width="260">
        <template slot-scope="scope">
          <el-button
            @click="move(scope.row, 'up')"
            v-if="inputWriteable && isRelate ? getBtnPermission('audit_process_management_relate_admin') : inputWriteable"
            size="small"
            icon="el-icon-arrow-up"
            plain
          ></el-button>
          <el-button
            @click="move(scope.row, 'down')"
            v-if="inputWriteable && isRelate ? getBtnPermission('audit_process_management_relate_admin') : inputWriteable"
            size="small"
            icon="el-icon-arrow-down"
            plain
          ></el-button>
          <el-button v-if="downloadable && showDownload" @click="download(scope.row)" size="small" icon="el-icon-download" plain></el-button>
          <el-button
            @click="removeFile(scope.row)"
            v-if="inputWriteable && isRelate ? getBtnPermission('audit_process_management_relate_admin') : inputWriteable"
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import utils from '@/eco-ui-util.js'
// import EcoFieldTail from "@/components/HtFieldTail.vue";
import FileUpload from '@/components/common/FileUpload.vue'

export default {
  name: 'eco-file',
  // props: [
  //   "withCredentials",
  //   "actionUrl",
  //   "value",
  //   "validate",
  //   "name",
  //   "multiple",
  //   "displayType",
  //   "permission",
  //   "accept",
  //   "limit",
  //   "header",
  //   "size",
  //   "previewable",
  //   "downloadable",
  //   "propConfList",
  //   "beforeUpload",
  //   "onSuccess",
  //   "onError",
  //   "columnShow",
  // ],
  props: {
    withCredentials: {
      type: Boolean,
      default: false
    },
    actionUrl: {
      type: String,
      default: 'https://jsonplaceholder.typicode.com/posts/'
    },
    value: {},
    expectParam: {
      type: Object
    },
    validate: {
      type: Object
    },
    name: {
      type: String
    },
    multiple: {
      type: Boolean,
      default: false
    },

    displayType: {
      type: String,
      default: 'table'
    },
    permission: {
      type: String,
      default: 'w',
      validator: function (value) {
        return ['b', 'w', 'r', 'n'].indexOf(value) !== -1
      }
    },
    accept: {
      type: String
    },
    limit: {
      type: Number
    },
    header: {
      type: Object
    },
    size: {
      type: Number,
      default: 100
    },
    previewable: {
      type: Boolean,
      default: true
    },
    downloadable: {
      type: Boolean,
      default: true
    },
    propConfList: {
      type: Array,
      default() {
        return []
      }
    },
    beforeUpload: {
      type: Function
    },
    onSuccess: {
      type: Function
    },
    onError: {
      type: Function
    },
    columnShow: {
      type: Object,
      default() {
        return {}
      }
    },
    showDownload: {
      type: Boolean,
      default() {
        return true
      }
    },
    inputWriteable: {
      type: Boolean,
      default() {
        return true
      }
    },
    isRelate: {
      type: Boolean,
      default: () => false
    }
  },
  components: { FileUpload },
  data() {
    return {
      inputName: null,
      files: [],
      filesData: []
    }
  },
  computed: {
    acceptLabel: function () {
      return this.accept ? this.accept : '所有格式'
    },
    // inputWriteable: function () {
    //   return utils.getWriteable(this.permission);
    // },
    inputValidate: function () {
      return utils.addRequiredOrNot(this.permission, this.validate, this)
    },
    calColumnShow: function () {
      let defaultSetting = { fileType: true, fileSize: true }
      return { ...defaultSetting, ...this.columnShow }
    }
  },
  watch: {
    filesData: function (newVal) {
      let r = ''
      if (newVal && newVal.constructor === Array && newVal.length > 0) {
        // 只有上传成功的附件才能更新v-model值
        let ary = newVal.filter((m) => m.status === 'success')
        if (ary && ary.length > 0) {
          if (this.displayType == 'picWall') {
            ary.forEach((e, i) => {
              if (!e.url && e.status == 'success') {
                ary.splice(i, 1)
              }
            })
          }
          r = JSON.stringify(ary)
        }
      }
      this.$emit('input', r)
    },
    files: function (newVal, oldVal) {
      if (!newVal || newVal.length == 0) {
        this.filesData = []
      } else if (newVal && newVal.constructor === Array) {
        let ary = []
        newVal.forEach((m, i) => {
          if (m && m.constructor === Object) {
            ary.push(m)
          } else if (m && m.constructor === File) {
            var name = m.name
            var index = name.lastIndexOf('.')
            var type = name.substring(index + 1, name.length)
            ary.push({
              name: name,
              size: m.size,
              percentage: m.percentage,
              status: m.status,
              state: m.state,
              response: m.response,
              type: type,
              uid: m.uid,
              url: m.url
            })
          }
        })
        if (this.displayType === 'picWall' && newVal !== oldVal) {
          if (ary && ary.length > 0) {
            ary.forEach((e, i) => {
              if (e.response && e.response.fileId && e.status == 'success' && !e.url) {
                this.$http
                  .get(
                    '${portal}/file/onlinePreviewController/v1/onlinePreview?fileId=' + e.response.fileId
                    // "&bucket=" +
                    // "eco-saas-qa"
                    // process.env.VUE_APP_BUCKET
                  )
                  .then((resp) => {
                    if (resp.data) {
                      e.url = resp.data.signedUrl
                      this.$set(this.files, i, e)
                    }
                  })
              }
            })
          }
        }
        this.$emit('input', JSON.stringify(ary))
      }
    },
    value: function (newVal) {
      if (newVal && newVal.constructor === String) {
        this.files = JSON.parse(newVal)
        this.filesData = JSON.parse(newVal)
      }
    }
  },
  created() {
    this.inputName = this.name ? this.name : utils.getName()
    this.$validator = this.$root.$validator
    if (this.value && this.value.constructor === String) {
      this.files = JSON.parse(this.value)
      this.filesData = JSON.parse(this.value)
    }
    // this.filesData = [];
    if (!this.displayType) {
      this.displayType = 'table'
    }
  },
  methods: {
    // 附件是否超过最大尺寸
    exceedFileSize(file) {
      return file.size > this.size * 1024 * 1024
    },
    handleBeforeUpload(file) {
      let resultVal = false

      if (this.exceedFileSize(file)) {
        let computerSize = this.$options.filters['computerSize'](file.size)
        this.$message.warning(`附件的大小为${computerSize}，超过了允许的最大尺寸${this.size}MB.`)
        resultVal = false
      } else {
        resultVal = true
      }

      if (this.beforeUpload && this.beforeUpload.constructor == Function && resultVal) {
        resultVal = this.beforeUpload(file)
      }

      if (resultVal) {
        this.files.push(file)
      }

      return resultVal
    },
    handleProgress(event, file, fileList) {
      const index = this.files.findIndex((m) => m === file)
      index > -1 && this.$set(this.files, index, file)
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多允许上传${this.limit}个附件.`)
    },
    handleSuccess(response, file, fileList) {
      // if (this.displayType === "picWall") {
      //   setTimeout(() => {
      //     if (response.mapErrors) {
      //       this.$emit("getError", response);
      //     }
      //     if (this.onSuccess && this.onSuccess.constructor == Function) {
      //       this.uploadSuccess(response, file, fileList);
      //     }
      //     const index = this.files.findIndex(m => m === file);
      //     file.state = "success";
      //     index > -1 && this.$set(this.files, index, file);
      //   }, 1500);
      // } else {
      if (response.mapErrors || response.errors || (response.failedList && response.failedList.length)) {
        this.$emit('getError', response)
      }
      if (this.onSuccess && this.onSuccess.constructor == Function) {
        this.uploadSuccess(response, file, fileList)
      }
      const index = this.files.findIndex((m) => m === file)
      file.state = 'success'
      index > -1 && this.$set(this.files, index, file)
      // }
    },
    handleError(err, file, fileList) {
      if (this.onError && this.onError.constructor == Function) {
        this.handleError(err, file, fileList)
      }
      const index = this.files.findIndex((m) => m === file)
      file.state = 'exception'
      index > -1 && this.$set(this.files, index, file)
      this.$message.error('附件' + file.name + '上传失败')
      setTimeout(() => {
        this.files.remove(file)
      }, 100)
    },
    handleClear() {
      this.$confirm('确定清空所有附件?').then(() => {
        this.files.forEach((m) => {
          this.abort(m)
        })
        this.$refs.elUploadEl.clearFiles()
        this.files = []
      })
    },
    // 重置
    resetFiles() {
      this.$refs.elUploadEl.clearFiles()
      this.files = []
    },
    abort(file) {
      // 附件还在上传中，则中止上传。
      if (file && file.status === 'uploading') {
        this.$refs.elUploadEl.abort(file)
      }
    },
    remove(file) {
      this.abort(file)
      for (var i = 0; i < this.files.length; i++) {
        if (this.files[i].uid == file.uid) {
          this.files.splice(i, 1) //删除数组某一项
        }
      }
      for (var i = 0; i < this.filesData.length; i++) {
        if (this.filesData[i].uid == file.uid) {
          this.filesData.splice(i, 1) //删除数组某一项
        }
      }
    },

    move(item, direct) {
      this.filesData = utils.arrayMove(this.filesData, item, direct)
    },
    uploadSuccess(response, file, fileList) {
      //获取附件类型
      let type = ''
      if (file.name && file.name.split('.')) {
        type = file.name.split('.')[file.name.split('.').length - 1]
      } else {
        type = file.type
      }

      this.filesData.push({
        name: file.name,
        size: file.size,
        percentage: file.percentage,
        status: file.status,
        state: file.status,
        response: file.response,
        type: type,
        uid: file.uid,
        url: file.url
      })
      // console.log(this.filesData, file, 123);
      this.$emit('onSuccess', response, file, fileList)
      this.$emit('uploadSuccess', response, file, fileList)
      // }
    },
    removeFile(file) {
      this.$confirm(`确定删除${file.name}?`)
        .then(() => {
          this.remove(file)
          this.$emit('remove', file, this.files)
        })
        .catch(() => {})
    },
    download(file) {
      this.$emit('download', file, this.files)
    },
    preview(file) {
      this.$emit('preview', file, this.files)
    }
  }
}
</script>
<style>
#fefile .el-table__footer-wrapper,
#fefile .el-table__header-wrapper {
  width: 100% !important;
}
#fefile .el-table__header,
#fefile .el-table__body,
#fefile .el-table__footer {
  width: 100% !important;
}
</style>
<style lang="stylus" scoped>
input[aria-invalid='true'] + div >>> button {
  border-color: #f56c6c;
}

.done-subject {
  cursor: pointer;
}

.done-subject:hover {
  color: #2761ff;
}

.el-upload {
  display: inline;
  text-align: center;
  cursor: pointer;
  outline: none;
}

div.file-upload-container > div {
  display: inline-block;
  margin-right: 10px;
}

.imgBg {
  background-size: contain !important;
  height: 100%;
  width: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  overflow-x: auto !important;
}
</style>
